import { createSelector } from '@ngrx/store';

import { AccessRoleTypes } from 'src/app/models/user.model';

import { userFeature } from './feature';

const { selectRoughagePlusAppRole } = userFeature;

const selectIsRoughagePlusAppCustomerOrAbove = createSelector(
  selectRoughagePlusAppRole,
  (role) => role !== undefined && role !== AccessRoleTypes.NotAuthorized,
);

const UserSelectors = {
  selectIsRoughagePlusAppCustomerOrAbove,
};

export default UserSelectors;
